<script>
import { Bubble } from "vue-chartjs";
import moment from "moment";
export default {
  name: "BubleChartButton",
  extends: Bubble,
  props: {
    label: {
      type: String
    },
    chartData: {
      type: Array
    },
  //  options: {
    //  type: Object
    //}
  },
  watch: {
    chartData(newChartData) {
    //  let dates = null;
      let totals = null;
      if (newChartData) {
     //  dates = this.chartData.map((d) => moment(d.d).format("LT"));
        const arrayC = newChartData.map((d) => {
            let data = []
           if(d.c.length != 0){      
                for( let i =0 ; i< d.c.length; i++){ 
                 var dateFormat = moment('2024-05-08 ' + d.c[i].time).format('h:mm a');
                 var partes = dateFormat.split(':');
                 var horas = parseInt(partes[0], 10); // Convierte las horas a entero
                 var minutosAMPM = partes[1].split(' '); // Separa los minutos y AM/PM
                 var minutos = parseInt(minutosAMPM[0], 10); // Convierte los minutos a entero
                 var ampm = minutosAMPM[1]; // Obtiene AM/PM
                 if (ampm.toLowerCase() === 'pm' && horas < 12) {
                    horas += 12;
                }
                var fecha = new Date(d.d);
                fecha.setHours(horas, minutos, 0, 0);
                 data.push({x: fecha , y: d.c[i].state, r: 10})
                }  
            }
            return data
         });
         const array = arrayC.filter(element => element !== undefined);
         totals = array.reduce((combinedArray, array) => combinedArray.concat(array), []);
      }
      this.renderChart(
        {
          datasets: [
            {
              label: "Acciones del boton",
              data:  totals,
              backgroundColor: function(context) {
                if(context.dataset.data.length !== 0) {
              var value = context.dataset.data[context.dataIndex].y;
              if (value === 'double') {
                 return 'rgba(253, 216, 53, 0.6)'; // Asigna color para 'double'
              } else if (value === 'long') {
                 return 'rgba(57, 73, 171, 0.6)'; // Asigna color para 'long'
              } else {
                 return 'rgba(211, 47, 47, 0.6)'; // Asigna color predeterminado para otros valores
              }   
              }
               },
            }
          ]
        },
        {
            responsive: true,
            maintainAspectRatio: false,
       legend: {
             display: true,
             position: 'top',
         labels: {
             fontColor: 'rgba(0, 0, 0, 0.7)'
    }

  },
  scales: {
    xAxes: [{
        type: 'time',
        position: 'bottom',
        time: {
        unit: 'hour',
        stepSize: 1, 
         displayFormats: {
         hour: 'h:mm a' 
            }
        },
        min: '2024-01-01T00:00:00', // Establece la hora mínima en 12:00 AM
        max: '2024-01-01T23:00:00',
        ticks: {
        autoSkip: false,
        maxTicksLimit: 24
      }   
    }],
    yAxes: [{
            id: 'y2',
            beginAtZero: true,
            type: 'category',
            labels: ['short', 'double', 'long'],
            offset: true,
            position: 'left',
            stackWeight: 1,
          }]
  }
        }
      );
    }
  },
  async mounted() {
  // let dates = null;
   let totals = null;
    if (this.chartData !== undefined) {
    // dates = this.chartData.map((d) => moment(d.d).format("LT"));
    let arrayC = this.chartData.map((d) => {
            let data = []
            if(d.c.length != 0){  
                for( let i =0 ; i< d.c.length; i++){ 
                 var dateFormat = moment('2024-05-08 ' + d.c[i].time).format('h:mm a');
                 var partes = dateFormat.split(':');
                 var horas = parseInt(partes[0], 10); // Convierte las horas a entero
                 var minutosAMPM = partes[1].split(' '); // Separa los minutos y AM/PM
                 var minutos = parseInt(minutosAMPM[0], 10); // Convierte los minutos a entero
                 var ampm = minutosAMPM[1]; // Obtiene AM/PM
                 if (ampm.toLowerCase() === 'pm' && horas < 12) {
                    horas += 12;
                }
                var fecha = new Date(d.d);
                fecha.setHours(horas, minutos, 0, 0);
                 data.push({x: fecha, y: d.c[i].state, r: 10})
                }            
            }   
            return data   
         });
         let array = arrayC.filter(element => element !== undefined);
         totals = array.reduce((combinedArray, array) => combinedArray.concat(array), [])
    }
    this.renderChart(
      {
        datasets: [
          {
            label: "Acciones del boton",
            data: totals,
            backgroundColor: function(context) {
             if(context.dataset.data.length !== 0) {
              var value = context.dataset.data[context.dataIndex].y;
              if (value === 'double') {
                 return 'rgba(253, 216, 53, 0.6)'; // Asigna color para 'double'
              } else if (value === 'long') {
                 return 'rgba(57, 73, 171, 0.6)'; // Asigna color para 'long'
              } else {
                 return 'rgba(211, 47, 47, 0.6)'; // Asigna color predeterminado para otros valores
              }   
            }
               },
          }
         
        ]
      },
      {
        responsive: true,
  maintainAspectRatio: false,
  legend: {
    display: true,
    position: 'top',
    labels: {
      fontColor: 'rgba(0, 0, 0, 0.7)'
    }
  },
  scales: {
    xAxes: [{
        type: 'time',
        position: 'bottom',
        time: {
        unit: 'hour',
        stepSize: 1, 
         displayFormats: {
         hour: 'h:mm a' 
            }
        },
        min: '2024-01-01T00:00:00', // Establece la hora mínima en 12:00 AM
        max: '2024-01-01T23:00:00',
        ticks: {
        autoSkip: false,
        maxTicksLimit: 24
      }       
    }],
    yAxes: [{
            id: 'y2',
            type: 'category',
            labels: ['short', 'double', 'long'],
            offset: true,
            position: 'left',
            stackWeight: 1,
          }]
  }
      }
    );
  }
};
</script>
<style lang="scss"></style>
